// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initFormatters } from './formatters';
import type { Locales, Translations } from './i18n-types';
import { loadedFormatters, loadedLocales, locales } from './i18n-util';

import de from './de';
import en from './en';
import es from './es';
import fa from './fa';
import fr from './fr';
import it from './it';
import pt from './pt';
import ru from './ru';

const localeTranslations = {
  de,
  en,
  es,
  fa,
  fr,
  it,
  pt,
  ru,
};

export const loadLocale = (locale: Locales): void => {
  if (loadedLocales[locale]) return;

  loadedLocales[locale] = localeTranslations[locale] as unknown as Translations;
  loadFormatters(locale);
};

export const loadAllLocales = (): void => locales.forEach(loadLocale);

export const loadFormatters = (locale: Locales): void => void (loadedFormatters[locale] = initFormatters(locale));
